import { TbInfoCircle } from 'react-icons/tb';

/** A small info icon in a panel's bar whose tooltip says what the panel's things are for. */
export function PanelInfo({ text }: { text: string }) {
  return (
    <span
      className="navigator-beacons-panel__info"
      role="img"
      aria-label={text}
      data-tooltip-id="main-tooltip"
      data-tooltip-content={text}
      data-tooltip-place="bottom"
      data-tooltip-class-name="navigator-beacons-panel__info-tooltip"
    >
      <TbInfoCircle />
    </span>
  );
}
